import Axios from "axios";
import _ from "lodash";
import jwtDecode from "jwt-decode";

const AUTH0_CLIENT_ID_STAGING = "l1fv302czTdpNdv3abSPdNJHUIJ7QaLD";
const AUTH0_CLIENT_SECRET_STAGING =
  "pYxCcfKQi1nROuzKOoZw_ab-5kyI7112f_Eq-FKPSqoGs9gzV2g7eRfMs9q_cJQT";
const AUTH0_LOGIN_BASE_URI_STAGING = "https://login-s.freightverify.com";

const AUTH0_CLIENT_ID_TEST = "5fNJ1aQe6mkvdVqaWwjMIqQRM8q2XUrv";
const AUTH0_CLIENT_SECRET_TEST =
  "fZUdF6BtgLWTnbXJs6RSVupFZzbkMH36b1AX8Xhqf5T-FCJAgYxgfKpPOKJAo8v5";
const AUTH0_LOGIN_BASE_URI_TEST = "https://login-t.freightverify.com";

const AUTH0_CLIENT_ID_PROD = "25bPZYkU3nnJhXNmQQxq5O9H8eNfkbFa";
const AUTH0_CLIENT_SECRET_PROD =
  "mAnPacnVpSsmlscyj3G071mR9c0POMqgRynM4qn5tw6kI6ecZ7vLvieRnNuzgXZr";
const AUTH0_LOGIN_BASE_URI_PROD = "https://login.freightverify.com";

const HOSTNAME_PROD = "portal.freightverify.com";

const AUDIENCE = "urn:fv-api";
const REDIRECT_URI = "https://" + window.location.hostname + "/callback";

const STAGING_HOSTNAME_LIST = [
  "localhost",
  "beta.freightverify.com",
  "fv-react-auth0.freightverify.com"
];

const TEST_HOSTNAME_LIST = [
  "fv-react-dev.freightverify.com",
  "portal-t.freightverify.com"
];

export default class Authentication {
  constructor() {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.setSession = this.setSession.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.getLastRequestedUrl = this.getLastRequestedUrl.bind(this);
    this.getEnvAuthBaseUri = this.getEnvAuth0BaseUri.bind(this);
    this.getEnvClientId = this.getEnvAuth0ClientId.bind(this);
    this.getEnvRedirectUri = this.getEnvRedirectUri.bind(this);
    this.isLoggingIn = this.isLoggingIn.bind(this);
    this.setIsLoggingIn = this.setIsLoggingIn.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);

    this.setIsLoggingIn(false);
  }

  handleAuthentication(code) {
    if (code) {
      this.setIsLoggingIn(true);
      const url = this.getEnvAuth0BaseUri() + `/oauth/token`;
      const params = {
        grant_type: "authorization_code",
        scope: "openid profile",
        client_id: this.getEnvAuth0ClientId(),
        client_secret: this.getEnvAuth0ClientSecret(),
        code: code,
        redirect_uri: this.getEnvRedirectUri()
      };

      Axios.post(url, params)
        .then(resp => {
          this.setSession(resp.data);
          const url = this.getLastRequestedUrl();
          this.setLastRequestedUrl("");

          if (url) {
            window.location.href = url;
          } else {
            window.location.href = "/";
          }
        })
        .catch(error => {
          window.location.href = "/verifyUserError";
        });
    }
  }

  isAuthenticated() {
    let expiresAt = JSON.parse(sessionStorage.getItem("expires_at"));
    return new Date().getTime() < expiresAt;
    //return expiresAt > 0;
  }

  isLoggingIn() {
    return sessionStorage.getItem("isLoggingIn");
  }

  login() {
    window.location.href = `${this.getEnvAuth0BaseUri()}/authorize?scope=openid%20profile&response_type=code&client_id=${this.getEnvAuth0ClientId()}&audience=${AUDIENCE}&redirect_uri=${this.getEnvRedirectUri()}`;
  }

  logout() {
    // Clear access token and ID token from local storage
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("id_token");
    sessionStorage.removeItem("expires_at");
    //sessionStorage.removeItem('refresh_token');
    sessionStorage.removeItem("last_requested_url");
    sessionStorage.removeItem("isLoggingIn");
    sessionStorage.removeItem("currentOrganization");

    window.location.href = "/";
  }

  setSession(authResult) {
    let expiresAt = JSON.stringify(
      authResult.expires_in * 1000 + new Date().getTime()
    );
    sessionStorage.setItem("access_token", authResult.access_token);
    sessionStorage.setItem("id_token", authResult.id_token);
    sessionStorage.setItem("expires_at", expiresAt);
    //sessionStorage.setItem('refresh_token', authResult.refresh_token);
    sessionStorage.setItem("isLoggingIn", false);
  }

  setLastRequestedUrl(url) {
    sessionStorage.setItem("last_requested_url", url);
  }

  setIsLoggingIn(flag) {
    sessionStorage.setItem("isLoggingIn", flag);
  }

  getLastRequestedUrl() {
    return sessionStorage.getItem("last_requested_url");
  }

  getIdToken() {
    return sessionStorage.getItem("id_token");
  }

  getAccessToken() {
    return sessionStorage.getItem("access_token");
  }

  getExpiresAt() {
    return sessionStorage.getItem("expires_at");
  }

  getDecodedToken() {
    return jwtDecode(sessionStorage.getItem("access_token"));
  }

  getDecodedIdToken() {
    return jwtDecode(sessionStorage.getItem("id_token"));
  }

  getEnvAuth0BaseUri() {
    if (_.includes(STAGING_HOSTNAME_LIST, window.location.hostname)) {
      return AUTH0_LOGIN_BASE_URI_STAGING;
    } else if (_.includes(TEST_HOSTNAME_LIST, window.location.hostname)) {
      return AUTH0_LOGIN_BASE_URI_TEST;
    } else if (window.location.hostname.indexOf(HOSTNAME_PROD) >= 0) {
      return AUTH0_LOGIN_BASE_URI_PROD;
    }

    return "";
  }

  getEnvAuth0ClientId() {
    if (_.includes(STAGING_HOSTNAME_LIST, window.location.hostname)) {
      return AUTH0_CLIENT_ID_STAGING;
    } else if (_.includes(TEST_HOSTNAME_LIST, window.location.hostname)) {
      return AUTH0_CLIENT_ID_TEST;
    } else if (window.location.hostname.indexOf(HOSTNAME_PROD) >= 0) {
      return AUTH0_CLIENT_ID_PROD;
    }

    return "";
  }

  getEnvAuth0ClientSecret() {
    if (_.includes(STAGING_HOSTNAME_LIST, window.location.hostname)) {
      return AUTH0_CLIENT_SECRET_STAGING;
    } else if (_.includes(TEST_HOSTNAME_LIST, window.location.hostname)) {
      return AUTH0_CLIENT_SECRET_TEST;
    } else if (window.location.hostname.indexOf(HOSTNAME_PROD) >= 0) {
      return AUTH0_CLIENT_SECRET_PROD;
    }

    return "";
  }

  getEnvRedirectUri() {
    if (window.location.hostname.indexOf("localhost") >= 0) {
      return (
        "http://" +
        window.location.hostname +
        ":" +
        window.location.port +
        "/callback"
      );
    } else {
      return REDIRECT_URI;
    }
  }

  installAuthInterceptor(tokenGetter = this.getAccessToken) {
    Axios.interceptors.request.use(function(config) {
      const token = tokenGetter();
      if (_.isEmpty(token)) {
        return config;
      }

      const activeOrgHeader = sessionStorage.getItem("currentOrganization")
        ? sessionStorage.getItem("currentOrganization")
        : "";

      const authHeaders = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "X-Active-Org": activeOrgHeader
      };

      const headers = Object.assign({}, config.headers, authHeaders);
      return Object.assign({}, config, {
        headers
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/authentication.js